import React, { Component, forwardRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Hidden, withStyles, CircularProgress } from '@material-ui/core'
import conversationItemTypes from './conversationItemTypes'
import {
	List as VirtualizedList,
	AutoSizer,
	CellMeasurer,
	CellMeasurerCache,
} from 'react-virtualized'
import { read } from 'actions/data'
import { readEmail } from 'actions/inbox'
import { REQUEST, FAILURE } from 'utils/statusConstants'
import { itemsInConversationSearch } from 'selectors/inbox'
import { isEqual } from 'lodash'

const ConnectedThread = connect(
  state => ({
    itemsInConversationSearch: itemsInConversationSearch(state),
    conversationSearch: state.inbox.conversationSearch,
    threadItem:
      state.inbox.conversationSelected === state.inbox.conversation.contact_id
        ? state.inbox.conversation
        : {},
    recentlySent:
      ((state.inbox.contactSelected || state.inbox.conversationSelected) &&
        state.inbox.recentlySent[
          (state.inbox.contactSelected && state.inbox.contactSelected.id) ||
            state.inbox.conversationSelected
        ] &&
        state.inbox.recentlySent[
          (state.inbox.contactSelected && state.inbox.contactSelected.id) ||
            state.inbox.conversationSelected
        ].newConversation) ||
      [],
    contact: state.inbox.conversation && state.inbox.conversation.contact,
    emailsLoaded: Object.keys(state.inbox.emailsLoaded).reduce((acc, cur) => {
      acc[cur] = true
      return acc
    }, {}),
    conversationSelected: state.inbox.conversationSelected,
    whatever: state.inbox.whatever,
  }),
  dispatch => bindActionCreators({ readEmail, read }, dispatch),
)(
  withStyles(theme => {
    return {
      threadItemContainer: {
        padding: '10px 20px 10px 60px',
        position: 'relative',
      },
      threadItem: {
        backgroundColor: '#f1f1f1',
        padding: '12px 16px 12px 62px',
        borderRadius: 13,
        position: 'relative',
        minHeight: 64,
      },
      avatar: {
        position: 'absolute',
        top: 12,
        left: 12,
      },
      iconContainer: {
        position: 'absolute',
        top: '50%',
        left: 14,
        transform: 'translate(0, -50%)',
        textAlign: 'center',
      },
      icon: {
        fill: '#c2c2c2',
        fontSize: 30,
      },
      iconLabel: {
        fontSize: 10,
        color: '#c2c2c2',
        marginTop: '-4px',
      },
      textList: {
        height: 'calc(100vh - 229px)',
        '@media (max-width: 1170px)': {
          height: 'calc(100vh - 269px)',
        },
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 269px)',
        },
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 260px)',
        },
      },
      emailList: {
        height: 'calc(100vh - 495px)',
        '@media (max-width: 1170px)': {
          height: 'calc(100vh - 577px)',
        },
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 535px)',
        },
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 568px)',
        },
      },
      callList: {
        height: 'calc(100vh - 301px)',
        '@media (max-width: 1170px)': {
          height: 'calc(100vh - 340px)',
        },
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 340px)',
        },
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 332px)',
        },
      },
      messageMenuClosed: {
        height: 'calc(100vh - 180px)',
        '@media (max-width: 1170px)': {
          height: 'calc(100vh - 220px)',
        },
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 220px)',
        },
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 212px)',
        },
      },
    }
  })(
    class Thread extends Component {
      constructor() {
        super()
        this.cache = new CellMeasurerCache({
          fixedWidth: true,
          defaultHeight: 110,
        })
        this.largeCache = new CellMeasurerCache({
          fixedWidth: true,
          defaultHeight: 110,
        })

        this.state = {
          resizing: false,
          height: 0,
          scrolledToBottom: false,
        }
      }

      componentDidMount() {
        window.addEventListener('resize', this.onResize)
      }

      componentDidUpdate(prevProps, prevState) {
        if (
          this.normalList &&
          this.normalList.forceUpdateGrid &&
          this.normalList.scrollToRow &&
          !this.state.scrolledToBottomFirstNormal
        ) {
          // TODO: figure out a more robust solution
          this.normalList.forceUpdateGrid()
          this.normalList.scrollToRow(this.list().length - 1)
          this.setState({ scrolledToBottomFirstNormal: true })
        }

        if (
          this.largeList &&
          this.largeList.forceUpdateGrid &&
          this.largeList.scrollToRow &&
          !this.state.scrolledToBottomFirstLarge
        ) {
          this.largeList.forceUpdateGrid()
          this.largeList.scrollToRow(this.list().length - 1)
          this.setState({ scrolledToBottomFirstLarge: true })
        }

        setTimeout(() => {
          if (
            this.largeList &&
            this.largeList.forceUpdateGrid &&
            this.largeList.scrollToRow &&
            !this.state.scrolledToBottomSecondLarge
          ) {
            this.largeList.forceUpdateGrid()
            this.largeList.scrollToRow(this.list().length - 1)
            this.setState({ scrolledToBottomSecondLarge: true })
          }

          if (
            this.normalList &&
            this.normalList.forceUpdateGrid &&
            this.normalList.scrollToRow &&
            !this.state.scrolledToBottomSecondNormal
          ) {
            // TODO: figure out a more robust solution
            this.normalList.forceUpdateGrid()
            this.normalList.scrollToRow(this.list().length - 1)
            this.setState({ scrolledToBottomSecondNormal: true })
          }
        }, 750)

        setTimeout(() => {
          if (
            this.largeList &&
            this.largeList.forceUpdateGrid &&
            this.largeList.scrollToRow &&
            !this.state.scrolledToBottomThirdLarge
          ) {
            this.largeList.forceUpdateGrid()
            this.largeList.scrollToRow(this.list().length - 1)
            this.setState({ scrolledToBottomThirdLarge: true })
          }

          if (
            this.normalList &&
            this.normalList.forceUpdateGrid &&
            this.normalList.scrollToRow &&
            !this.state.scrolledToBottomThirdNormal
          ) {
            // TODO: figure out a more robust solution
            this.normalList.forceUpdateGrid()
            this.normalList.scrollToRow(this.list().length - 1)
            this.setState({ scrolledToBottomThirdNormal: true })
          }
        }, 1750)

        if (
          this.props.threadItem.contact_id !==
            prevProps.threadItem.contact_id ||
          this.props.threadItem.last_interaction !==
            prevProps.threadItem.last_interaction ||
          !isEqual(this.props.conversationSearch, prevProps.conversationSearch)
        ) {
          if (this.cache) {
            this.cache.clearAll()
          }
          if (this.normalList) {
            this.normalList.forceUpdateGrid()
            this.normalList.scrollToRow(this.list().length - 1)
          }
          if (this.largeList) {
            this.largeList.forceUpdateGrid()
            this.largeList.scrollToRow(this.list().length - 1)
          }
        }
      }

      componentWillUnmount() {
        window.removeEventListener('resize', this.onResize)
      }

      list = () => {
        const { itemsInConversationSearch } = this.props

        return itemsInConversationSearch
      }

      listItem = index => {
        const { contact } = this.props
        const conversationItem = this.list()[index]
        const unknown = () => <div>unknown</div>

        const Component =
          (conversationItem &&
            conversationItem.type &&
            conversationItemTypes[conversationItem.type] &&
            conversationItemTypes[conversationItem.type].component) ||
          unknown

        return (
          <Component
            index={index}
            contact={contact}
            conversationItem={conversationItem}
            key={`conversationItem${conversationItem.timestamp}${conversationItem.type}`}
          />
        )
      }

      renderRow = ({ index, key, style, parent }) => {
        const listItem = this.list()[index]
        const { emailsLoaded, readEmail } = this.props

        if (listItem && listItem.type === 'email') {
          if (
            listItem.thread &&
            listItem.thread.emails &&
            listItem.thread.emails[0]
          ) {
            const lastEmailInThread = listItem.thread.emails[0]

            if (
              lastEmailInThread.full_email_uri &&
              !emailsLoaded[lastEmailInThread.full_email_uri] &&
              emailsLoaded[lastEmailInThread.full_email_uri] !== REQUEST &&
              emailsLoaded[lastEmailInThread.full_email_uri] !== FAILURE
            ) {
              readEmail(lastEmailInThread.full_email_uri).then(() => {
                if (this.cache) {
                  this.cache.clearAll()
                }
                if (this.normalList) {
                  this.normalList.forceUpdateGrid()
                }
              })
            }
          }
        }

        // if (listItem.type === 'formsub') {

        // }

        return (
          <CellMeasurer
            key={key}
            cache={this.cache}
            parent={parent}
            columnIndex={0}
            rowIndex={index}
          >
            <div style={style}>{this.listItem(index)}</div>
          </CellMeasurer>
        )
      }

      renderLargeRow = ({ index, key, style, parent }) => {
        const listItem = this.list()[index]
        const { emailsLoaded, readEmail } = this.props

        if (listItem && listItem.type === 'email') {
          if (
            listItem.thread &&
            listItem.thread.emails &&
            listItem.thread.emails[0]
          ) {
            const lastEmailInThread = listItem.thread.emails[0]

            if (
              lastEmailInThread.full_email_uri &&
              !emailsLoaded[lastEmailInThread.full_email_uri] &&
              emailsLoaded[lastEmailInThread.full_email_uri] !== REQUEST &&
              emailsLoaded[lastEmailInThread.full_email_uri] !== FAILURE
            ) {
              readEmail(lastEmailInThread.full_email_uri).then(() => {
                if (this.largeCache) {
                  this.largeCache.clearAll()
                }
                if (this.largeList) {
                  this.largeList.forceUpdateGrid()
                }
              })
            }
          }
        }

        return (
          <CellMeasurer
            key={key}
            cache={this.largeCache}
            parent={parent}
            columnIndex={0}
            rowIndex={index}
          >
            <div style={style}>{this.listItem(index)}</div>
          </CellMeasurer>
        )
      }

      bindListRef = ref => {
        this.normalList = ref
      }

      bindLargeListRef = ref => {
        this.largeList = ref
      }

      onResize = () => {
        clearTimeout(this.timeout)

        this.setState({ resizing: true })

        this.timeout = setTimeout(() => {
          this.setState({ resizing: false })
        }, 500)
      }

      render() {
        const { conversationSearch, conversationSelected, forwardedRef } =
          this.props
        const list = this.list()

        const largeHeight = forwardedRef?.current?.offsetHeight
          ? `calc(100vh - ${
              (forwardedRef?.current?.offsetHeight || 0) + 139
            }px)`
          : undefined

        // const smHeight = forwardedRef?.current?.offsetHeight
        //   ? `calc(100vh - ${
        //       (forwardedRef?.current?.offsetHeight || 0) + 139
        //     }px)`
        //   : undefined

        const xsHeight = forwardedRef?.current?.offsetHeight
          ? `calc(100vh - ${
              (forwardedRef?.current?.offsetHeight || 0) + 131
            }px)`
          : undefined

        const filtered = !isEqual(conversationSearch, {
          From: null,
          To: null,
          sms: true,
          email: true,
          call: true,
          formsub: true,
          search: '',
        })

        if (this.state.resizing) {
          return (
            <div style={{ height: '100%', position: 'relative' }}>
              <div
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <CircularProgress />
              </div>
            </div>
          )
        }

        const comp = (
          <>
            <Hidden mdDown>
              <AutoSizer>
                {({ width, height }) => (
                  <VirtualizedList
                    ref={this.bindLargeListRef}
                    width={width}
                    height={height}
                    deferredMeasurementCache={this.largeCache}
                    rowHeight={this.largeCache.rowHeight}
                    rowRenderer={this.renderLargeRow}
                    rowCount={list.length}
                    overscanRowCount={3}
                  />
                )}
              </AutoSizer>
            </Hidden>
            <Hidden lgUp>
              <AutoSizer>
                {({ width, height }) => (
                  <VirtualizedList
                    ref={this.bindListRef}
                    width={width}
                    height={height}
                    deferredMeasurementCache={this.cache}
                    rowHeight={this.cache.rowHeight}
                    rowRenderer={this.renderRow}
                    rowCount={list.length}
                    overscanRowCount={3}
                  />
                )}
              </AutoSizer>
            </Hidden>
          </>
        )

        return conversationSelected && !this.state.resizing ? (
          <>
            <Hidden smDown>
              <div
                style={
                  filtered
                    ? { border: '1px solid #014c94', height: largeHeight }
                    : { height: largeHeight }
                }
              >
                {comp}
              </div>
            </Hidden>
            {/* <Hidden only={['xl', 'lg', 'md', 'xs']}>
              <div
                style={
                  filtered
                    ? { border: '1px solid #014c94', height: smHeight }
                    : { height: smHeight }
                }
              >
                {comp}
              </div>
            </Hidden> */}
            <Hidden mdUp>
              <div
                style={
                  filtered
                    ? { border: '1px solid #014c94', height: xsHeight }
                    : { height: xsHeight }
                }
              >
                {comp}
              </div>
            </Hidden>
          </>
        ) : null
      }
    },
  ),
)

export default forwardRef((props, ref) => (
	<ConnectedThread {...props} forwardedRef={ref} />
))
